import { LoadingOutlined } from "@ant-design/icons";
import { ICompany } from "@/types";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { useFetchCompaniesQuery } from "@services";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { paths } from "@/router";
import CompanySelectCarousel from "@components/caurosel";
import CompanyList from "@/components/List/company-list";
import { BiChevronRight } from "react-icons/bi";

const CompanyUser = () => {
  const history = useHistory();
  const [page] = useState(1);
  const [searchString, setSearchString] = useState<string>("");
  const [isCompanySelected, setIsCompanySelected] = useState<boolean>(false);
  // const [selectedCompany, setselectedCompany] = useState<ICompany>();
  const [selectedCompany, setselectedCompany] = useState<string | null>(null);
  const { data: companiesData, isLoading: isFetching } =
    useFetchCompaniesQuery(page);
  const { data } = companiesData || {};

  const onPressNext = (companyId: any) => {
    setIsCompanySelected(true);
    history.push(
      `${paths.client.users.company_users.company_user}/list/${companyId}`
    );
  };
  let handleCompanySelect = (app: any) => {
    setselectedCompany(app);
    setSelectedCompanyInStorage(app);
    onPressNext(app);
  };

  if (!isCompanySelected) {
    return (
      <div className="ApplicationSelector  w-full px-12">
        {isFetching ? (
          // <div className="flex justify-center items-center mt-28">
          //   <LoadingOutlined className="spinner" />
          // </div>
          <div
            style={{ height: "650px" }}
            className="flex justify-center items-center "
          >
            <LoadingOutlined
              className="spinner "
              style={{ fontSize: "80px" }}
            />
          </div>
        ) : (
          <main className="relative min-h-screen bg-[#FAFAFA] px-8 py-8 mt-10">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-10">
                <h1 className="text-4xl font-semibold text-[#4A4A4A] mb-3">
                  Select The Company
                </h1>

                <p className="text-sm font-medium text-[#6F6F6F]">
                  Choose A Company To Access And Manage Its Operations
                </p>
              </div>

              {/* Company Count */}
              <div className="flex justify-end mb-3">
                <span className="text-xs text-[#6F6F6F]">
                  {data?.length || 0} of {data?.length || 0} companies
                </span>
              </div>

              {/* Company List */}
              <div className="max-w-6xl">
                <CompanyList
                  companiesList={data && data}
                  onSelectCompany={setselectedCompany}
                  selectedCompany={selectedCompany}
                />
              </div>

              {/* Continue Button */}
              {selectedCompany && (
                <div className="mt-10 flex justify-center">
                  <button
                    onClick={() => handleCompanySelect(selectedCompany)}
                    className="
            w-80
            h-12
            rounded
            text-white
            font-medium
            transition-all
            duration-200
            hover:opacity-90
            flex
            items-center
            justify-center
            gap-2
          "
                    style={{
                      backgroundColor: "#F7935A",
                    }}
                  >
                    {
                      data?.find((item: any) => item?.id == selectedCompany)
                        ?.name
                    }
                    <BiChevronRight className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          </main>
        )}
      </div>
    );
  }
};

export default CompanyUser;
